export enum SubStatus {
  NotStarted,
  InProgress,
  Completed,
  Error,
}

export enum VisionInstallSubStep {
  Start = 'Start',
  Camera = 'Camera',
  Distance = 'Distance',
}

export enum VisionPendingKind {
  Camera = 'camera',
  Distance = 'distance',
}
